import { BaseService } from 'core/services';
import ESignPreferenceRouteService from './ESignPreferenceRouteService';

class ESignPreferenceService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new ESignPreferenceRouteService());
    }
}

export default ESignPreferenceService;
